export default __webpack_public_path__ + "static/media/PropertyDev_Shapes-01.9d3ff6dc.png";